<template>
  <b-modal
    id='permanent-exhibition'
    size='xl'
    ref='permanent-exhibition'
    scrollable
    @show='showModal'
    @hidden='hideModal()'
  >
    <!--Modal de Orientação atualizada sobre exposição permanente-->
    <b-modal
      size='xl'
      ref='guidanceOnTopic'
      id='guidanceOnTopic'
      scrollable
      hide-footer
    >
      <template #modal-header>
        <section class='guidanceOnTopic'>
          <section class='d-flex'>
            <a @click='hideQuidanceOnTopic()'>
              <svg xmlns='http://www.w3.org/2000/svg' width='35' height='35' viewBox='0 0 24 24' fill='none'>
                <path d='M9 14L5 10L9 6' stroke='#022245' stroke-width='2' stroke-linecap='round'
                      stroke-linejoin='round' />
                <path
                  d='M5 10H16C17.0609 10 18.0783 10.4214 18.8284 11.1716C19.5786 11.9217 20 12.9391 20 14C20 15.0609 19.5786 16.0783 18.8284 16.8284C18.0783 17.5786 17.0609 18 16 18H15'
                  stroke='#022245' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
              </svg>
            </a>
            <span class='title ml-3'>
              Orientação atualizada sobre exposição permanente
            </span>
          </section>
        </section>
      </template>
      <section class='guidanceOnTopic'>
        <p>
          A necessidade da exposição permanente para fins de enquadramento dos agentes químicos no LTCAT é mencionada,
          entre outras,
          no Decreto 3.048, de 6 de maio de 1999 no seu Art. 68. Para tanto o conceito mais atual sobre o que é uma
          exposição
          permanente vem através da INSTRUÇÃO NORMATIVA PRES/INSS No 128, DE 28 DE MARÇO DE 2022:
        </p>

        <p>
          <i>
            "Art. 268. Para fins de concessão de aposentadoria especial, será exigida a comprovação do exercício da
            atividade
            de forma permanente,
          </i>

          <span>
            entendendo-se como <strong>permanente o trabalho não ocasional nem intermitente, no qual a efetiva
            exposição do trabalhador ao agente prejudicial à saúde é indissociável da produção do bem ou da prestação de
            serviço, exercida em condições especiais que prejudiquem a saúde, </strong>
          </span>
          <i>
            durante o período de 15 (quinze), 20 (vinte) ou 25 (vinte e cinco) anos." (grifos nossos)
          </i>
        </p>

        <b-tooltip target='paragrafo_01' placement='auto' triggers='hover'>
          <p class='text-center'>
            <strong>
              BATISTA, Homero. Capítulo 3. Sobre a Habitualidade da Prestação de Serviços Em: Batista,
              Homero. Direito do Trabalho Aplicado: Teoria Geral de Direito do Trabalho e do Direito Sindical.
              São Paulo (SP): Editora Revista dos Tribunais. 2021.
            </strong>
          </p>
        </b-tooltip>

        <p id='paragrafo_01'>
          A partir das marcações acima, destaca-se que:<br />
          1) Para o grifo "<span><strong>permanente o trabalho não ocasional nem intermitente</strong></span>": "A noção
          de permanência tem que ver com a repetição ou
          a expectativa da repetição e não propriamente com a duração, em número de horas, dessa exposição.
          A noção de habitualidade, palavra que preferimos às expressões ineventualidade ou não eventualidade,
          viceja muito mais na repetição razoavelmente esperada do que propriamente no número de dias da semana
          ou no número de horas laboradas.
          Se fosse assim, não haveria nem sequer o contrato de trabalho a tempo parcial nem se poderia falar em trabalho
          do médico plantonista, pois esses e outros casos teriam carga horária muito baixa quando comparados aos
          empregados do
          sistema integral de jornada.<br />

          O que prevalece, num ou noutro caso, é a noção do trato sucessivo, no sentido de que aquelas mesmas condições
          de
          trabalho e de contraprestação se repitam sucessivamente, sem maior alarde ou necessidade de repactuação a
          todo instante (e, adianto desde logo, o contrato de trabalho intermitente, inserido no Brasil pela reforma
          trabalhista de 2017, será também ele considerado no plano da habitualidade, ainda que o empregado seja
          acionado pouquíssimas vezes).
          <br />
          Expectativa é a palavra-chave." (Batista, 2021)
        </p>

        <p>
          2) Para o grifo "<span><strong>efetiva exposição</strong></span>": a exposição a qual o trabalhador de fato
          tem contato com o agente químico, seja ela
          (a exposição) via dermal ou respiratória, independentemente da forma como o agente químico se apresenta no
          ambiente.
          (HO Fácil Web, 2024)
        </p>

        <p>
          3) Para o grifo "<span><strong>indissociável da produção do bem ou da prestação de serviço</strong></span>":
          toda exposição com o agente químico
          que obrigatoriamente acontece durante a atividade, ou seja, é necessária e faz parte para que a atividade seja
          executada, é considerada como indissociável. (HO Fácil Web, 2024)
        </p>

        <b-tooltip target='paragrafo_02' placement='auto' triggers='hover'>
          <a href='https://drive.google.com/file/d/14xgFajBx6Ob_bsDhi5d0AJ4nsBQWMu2q/view?usp=sharing' target='_blank'>
            <p>Clique aqui para acessar a nota técnica</p>
          </a>
        </b-tooltip>

        <section id='paragrafo_02'>
          <p>
            4) Para o grifo "<span><strong>condições especiais que prejudiquem a saúde</strong></span>": Em 2022 a
            Fundacentro emitiu uma nota técnica a qual sugere um
            passo a passo para reconhecer o potencial nocivo (condições que prejudiquem a saúde) do trabalhador. Essa
            orientação da
            Fundacentro encontra-se no tópico 2.10 (link para acesso da nota técnica).
            Destaca-se ainda que o HO Fácil Web traz para muitos agentes químicos informações prontas de forma que o
            usuário não
            precise interagir para reconhecer o potencial nocivo do risco. <br />

            Menciona-se também dois conceitos importantes para a base de argumentação sobre o potencial nocivo dos
            agentes químicos: <br />
          </p>
          <ul class='ml-3'>
            <li>
              <i>"Todas as substâncias, naturais ou sintéticas são potencialmente tóxicas; em outras palavras, podem
                produzir efeitos adversos
                para a saúde em alguma condição de exposição. É incorreto denominar algumas substâncias químicas como
                tóxicas e outras como
                não tóxicas. As substâncias diferem muito na toxicidade. As condições de exposição e a dose são fatores
                que determinam os
                efeitos tóxicos." </i> (Ottoboni, 1991)
            </li>

            <li>
              <i>“Todas as substâncias são tóxicas. Não há nenhuma que não seja tóxica. A dose estabelece a diferença
                entre um tóxico e um medicamento”. </i>
              (Frase atribuída a Paracelso, médico no século XVI e considerado o pai da toxicologia)
            </li>
          </ul>
        </section>
      </section>
    </b-modal>

    <template #modal-header>
      <section
        class='w-100 text-center position-relative align-items-center d-flex justify-content-center  modal-font-family'>
        <span class='title text-center'>Exposição Permanente</span>
        <a
          @click="hideEffectiveProtection()"
          class='d-flex align-items-center position-absolute float-right btn_close'
        >
          <b-icon
            class='ml-1 '
            font-scale='1.7'
            icon='x'
            color='#022245'
          >
          </b-icon>
        </a>
      </section>
    </template>

    <b-overlay
      :show='loading'
      rounded
      opacity='0.7'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
    >
      <section class='modal-font-family'>
        <section class=''>
          <p class='subtitle text-justify'>
            Com base nas suas respostas de <strong>“Sim” ou “Não”</strong> para as perguntas abaixo, poderemos <strong>orientá-lo
            tecnicamente</strong>
            sobre alguns dispositivos e interpretações da <strong>legislação previdenciária</strong>.
          </p>

          <p class='subtitle text-justify'>
            Essas informações também nos ajudarão a <strong>avaliar o enquadramento dos agentes no LTCAT e a aprimorar a
            análise
            de riscos</strong> relacionada à atividade realizada pelo trabalhador em contato com os agentes do
            respectivo produto
            químico.
          </p>

          <p class='subtitle'>
            <a href="#" @click='showQuidanceOnTopic()'>
              Clique aqui para ler a nossa orientação sobre o tema.
            </a>
          </p>
        </section>


        <!--A exposição ao agente químico ocorre de forma indissociável da função?-->
        <section class="mt-2">
          <section class='d-flex align-items-center'>
            <label>
              A exposição ao agente químico ocorre de forma indissociável da função?
            </label>

            <b-tooltip
              custom-class='custom-tooltip'
              target='exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao'
              triggers='hover' placement='auto'
            >
              <section>
                <p class="text-justify">
                  <strong>Orientação: </strong>
                  Existem situações em que o trabalhador pode realizar sua atividade <strong>sem utilizar produtos
                  químicos</strong>.
                  Nesses casos, entende-se que a exposição aos agentes químicos <strong>não é obrigatória</strong> e,
                  portanto, <strong>não é
                  indissociável da atividade</strong>.
                </p>
                <p class="text-justify">
                  Para facilitar o entendimento, imagine o caso de um <strong>jardineiro</strong> que pode optar por
                  utilizar ou não um
                  <strong>agrotóxico</strong> para realizar seu trabalho. Se o uso do agrotóxico <strong>for
                  opcional</strong>, a exposição ao agente
                  químico não é inerente à atividade, pois o trabalho pode ser executado sem esse produto.
                </p>
                <p class="text-justify">
                  Por outro lado, se o <strong>uso do agrotóxico for necessário</strong> para a execução da atividade,
                  então a exposição
                  aos agentes químicos passa a fazer parte do próprio trabalho. Nesse caso, a atividade e a exposição
                  aos agentes químicos <strong>são indissociáveis</strong>, pois o trabalhador inevitavelmente estará
                  potencialmente
                  exposto a esses agentes ao desempenhar sua função.
                </p>
                <p class="text-justify">
                  <strong>Letra de lei: “I</strong> - das circunstâncias de exposição ocupacional a determinado agente
                  ou associação de
                  agentes prejudiciais à saúde presentes no ambiente de trabalho durante toda a jornada de trabalho;
                  (Redação dada pelo Decreto nº 10.410, de 2020)"
                </p>

                <a :href='technicalGuidanceUrl' target='_blank' rel='noopener noreferrer'>
                  <strong>Clique aqui para ver nossa orientação técnica sobre</strong>
                </a>
              </section>
            </b-tooltip>

            <b-icon
              style='cursor: pointer; color: white'
              class='ml-1 mb-2'
              font-scale='1.3'
              icon='question-circle-fill'
              id='exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao'
              variant='info'>
            </b-icon>
          </section>

          <b-form-radio-group
            style="margin-top: -12px"
            :disabled='disabled'
            @change='updatePermanentExhibition()'
            class='justify-content-between b-form-radio-group'
            name='exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao'
            v-model='exposicaoPermanente.exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao'
          >
            <b-form-radio
              class='pt-2 mr-3'
              :value='true'
            >
              <span
                :class="exposicaoPermanente.exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao? 'selected': 'not-selected'"
              >
                Sim
              </span>
            </b-form-radio>

            <b-form-radio
              class='py-2 mr-5'
              :value='false'
            >
              <span
                :class="exposicaoPermanente.exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao === false ? 'selected': 'not-selected'"
              >
                Não
              </span>
            </b-form-radio>
          </b-form-radio-group>
        </section>

        <!--Foram identificadas todas as fontes e formas como o produto é liberado no ar ou no ambiente? -->
        <section class="mt-2">
          <section class='d-flex align-items-center'>
            <label>
              Foram identificadas todas as fontes e formas como o produto é liberado no ar ou no ambiente?
            </label>

            <b-tooltip
              custom-class='custom-tooltip'
              target='foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente'
              triggers='hover' placement='auto'
            >
              <section>
                <p class="text-justify">
                  <strong>Orientação: </strong>
                  <strong>A exposição dermal</strong> ocorre quando o trabalhador entra em contato com agentes químicos
                  <strong>através da pele</strong>.
                </p>

                <p class="text-justify">
                  <strong>A exposição respiratória (ou inalatória)</strong> ocorre quando o trabalhador entra em contato
                  com agentes químicos <strong>ao respirar o ar contaminado</strong>.
                </p>

                <p class="text-justify">
                  Uma forma prática de identificar <strong>exposição dermal</strong> é observar se o posto de trabalho
                  ou o próprio trabalhador apresentam <strong>sujidade</strong>,
                  ou seja, se há presença visível de produtos químicos na pele, roupas, equipamentos ou superfícies de
                  contato.
                </p>

                <p class="text-justify">
                  Para identificar exposição <strong>respiratória/inalatória</strong>, deve-se observar se há <strong>agentes
                  químicos dispersos no ar</strong>,
                  como vapores, gases, poeiras ou névoas, ou ainda <strong>resíduos acumulados em superfícies e no
                  chão</strong>, que podem se tornar suspensos no ar durante as atividades.
                </p>

                <p class="text-justify">
                  É importante lembrar que a <strong>ausência de cheiro não significa ausência de contaminação</strong>.
                  Muitos agentes
                  químicos podem estar presentes no ambiente em concentrações relevantes mesmo sem serem percebidos pelo
                  olfato.
                </p>

                <p class="text-justify">
                  <strong>Letra de lei: “II</strong> - de todas as fontes e possibilidades de liberação dos agentes
                  mencionados no inciso I; (Incluído pelo Decreto nº 8.123, de 2013)"
                </p>

                <a :href='technicalGuidanceUrl' target='_blank' rel='noopener noreferrer'>
                  <strong>Clique aqui para ver nossa orientação técnica sobre</strong>
                </a>
              </section>
            </b-tooltip>

            <b-icon
              style='cursor: pointer; color: white'
              class='ml-1 mb-2'
              font-scale='1.3'
              icon='question-circle-fill'
              id='foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente'
              variant='info'>
            </b-icon>
          </section>

          <b-form-radio-group
            style="margin-top: -12px"
            :disabled='disabled'
            @change='updatePermanentExhibition()'
            class='justify-content-between b-form-radio-group'
            name='foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente'
            v-model='exposicaoPermanente.foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente'
          >
            <b-form-radio
              class='pt-2 mr-3'
              :value='true'
            >
              <span
                :class="exposicaoPermanente.foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente? 'selected': 'not-selected'"
              >
                Sim
              </span>
            </b-form-radio>

            <b-form-radio
              class='py-2 mr-5'
              :value='false'
            >
              <span
                :class="exposicaoPermanente.foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente === false ? 'selected': 'not-selected'"
              >
                Não
              </span>
            </b-form-radio>
          </b-form-radio-group>
        </section>

        <!--A frequência em que o trabalhador realiza a atividade é previsível?-->
        <section class="mt-2">
          <section class='d-flex align-items-center'>
            <label>
              A frequência em que o trabalhador realiza a atividade é previsível?
            </label>

            <b-tooltip
              custom-class='custom-tooltip'
              target='frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade'
              triggers='hover' placement='auto'
            >
              <p class="text-justify">
                <strong>Orientação: </strong>
                A frequência é previsível quando o trabalhador realiza a atividade de forma contínua, habitual ou
                rotineira.
                Uma frequência previsível não precisa ser todos os dias em uma grande carga horária diária.
                Desde que seja sabido que o trabalhador costuma realizar a atividade já é suficiente para
                saber que a frequência é previsível.
              </p>
            </b-tooltip>

            <b-icon
              style='cursor: pointer; color: white'
              class='ml-1 mb-2'
              font-scale='1.3'
              icon='question-circle-fill'
              id='frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade'
              variant='info'>
            </b-icon>
          </section>

          <b-form-radio-group
            style="margin-top: -10px"
            :disabled='disabled'
            @change='updatePermanentExhibition()'
            class='justify-content-between'
            name='frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade'
            v-model='exposicaoPermanente.frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade'
          >
            <b-form-radio
              class='py-2 mr-3'
              :value='true'
            >
              <span
                :class="exposicaoPermanente.frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade ? 'selected': 'not-selected'"
              >
                Sim
              </span>
            </b-form-radio>

            <b-form-radio
              class='py-2 mr-3'
              :value='false'
            >
              <span
                :class="exposicaoPermanente.frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade === false ? 'selected': 'not-selected'"
              >
                Não
              </span>
            </b-form-radio>
          </b-form-radio-group>
        </section>

        <!--O trabalhador tem contato dermal e/ou respiratório ou até outra que possa trazer algum dano a sua saúde? -->
        <section class="mt-2">
          <section class='d-flex align-items-center'>
            <label>
              O trabalhador tem contato dermal e/ou respiratório ou até outra que possa trazer algum dano a sua saúde?
            </label>

            <b-tooltip
              custom-class='custom-tooltip'
              target='trabalhadorexecutaAtividadeAgentesQuimicosAnalisados'
              triggers='hover' placement='auto'
            >
              <section>
                <p class="text-justify">
                  <strong>Orientação: </strong>
                  Avalie se, durante a execução de suas atividades, o trabalhador possui <strong>
                  contato com agentes químicos,
                  físicos ou biológicos que possam causar algum dano à saúde
                </strong>, seja por via <strong>dermal (pele), via
                  respiratória/inalatória ou por outra forma de exposição relevante</strong>.
                </p>

                <p class="text-justify">
                  Considere como <strong>contato dermal</strong> as situações em que há possibilidade de o agente
                  atingir a pele do
                  trabalhador, como respingos, manipulação direta de produtos, superfícies contaminadas ou sujidade
                  visível na pele, roupas ou equipamentos.
                </p>

                <p class="text-justify">
                  Já o <strong>contato respiratório/inalatório</strong> ocorre quando o trabalhador pode respirar ar
                  contendo vapores,
                  gases, poeiras, névoas, fumos ou outras substâncias presentes no ambiente de trabalho.
                </p>

                <p class="text-justify">
                  Também devem ser observadas <strong>outras vias de exposição</strong>, como ingestão acidental ou
                  contato com mucosas
                  (olhos, boca, nariz), dependendo da natureza do agente e da atividade executada.
                </p>

                <p class="text-justify">
                  Para responder a esta pergunta, analise se, <strong>nas condições normais de trabalho</strong>, existe
                  possibilidade
                  real de o trabalhador entrar em contato com agentes que possam trazer algum <strong>efeito nocivo à
                  saúde</strong>,
                  considerando o processo de trabalho, os produtos utilizados, o ambiente e as tarefas realizadas.
                </p>


                <p class="text-justify">
                  <strong>Letra de lei</strong>: “III - dos meios de contato ou exposição dos trabalhadores, as vias de
                  absorção, a
                  intensidade da exposição, a frequência e a duração do contato. (Incluído pelo Decreto nº 8.123, de 2013)"
                </p>

                <a :href='technicalGuidanceUrl' target='_blank' rel='noopener noreferrer'>
                  <strong>Clique aqui para ver nossa orientação técnica sobre</strong>
                </a>
              </section>
            </b-tooltip>

            <b-icon
              style='cursor: pointer; color: white'
              class='ml-1 mb-2'
              font-scale='1.3'
              icon='question-circle-fill'
              id='trabalhadorexecutaAtividadeAgentesQuimicosAnalisados'
              variant='info'>
            </b-icon>
          </section>

          <b-form-radio-group
            style="margin-top: -12px"
            :disabled='disabled'
            @change='updatePermanentExhibition()'
            class='justify-content-between b-form-radio-group'
            name='trabalhadorexecutaAtividadeAgentesQuimicosAnalisados'
            v-model='exposicaoPermanente.trabalhadorexecutaAtividadeAgentesQuimicosAnalisados'
          >
            <b-form-radio
              class='pt-2 mr-3'
              :value='true'
            >
              <span
                :class="exposicaoPermanente.trabalhadorexecutaAtividadeAgentesQuimicosAnalisados? 'selected': 'not-selected'"
              >
                Sim
              </span>
            </b-form-radio>

            <b-form-radio
              class='py-2 mr-5'
              :value='false'
            >
              <span
                :class="exposicaoPermanente.trabalhadorexecutaAtividadeAgentesQuimicosAnalisados === false ? 'selected': 'not-selected'"
              >
                Não
              </span>
            </b-form-radio>
          </b-form-radio-group>
        </section>
      </section>

      <template v-slot:overlay>
        <div class='text-center loading-spinner'>
          <b-spinner
            style='width: 3rem; height: 3rem'
            variant='primary'
            label='Large Spinner'
          ></b-spinner>
          <h4 class='text-primary'>{{ loadingText }}</h4>
        </div>
      </template>
    </b-overlay>

    <template #modal-footer>
      <section class='d-flex mt-2 align-items-center justify-content-end modal-font-family'>
        <b-button
          @click='resetPermanentExhibition()'
          variant='danger'
          class='px-3 mr-3 d-flex align-items-center'
        >
          <b-icon
            icon='arrow-repeat'
            color='#FFFFFF'
          >
          </b-icon>
          <span class='label ml-1'>Limpar respostas selecionadas</span>
        </b-button>

        <b-button
          class='px-3 d-flex align-items-center'
          variant='success'
          @click="hideEffectiveProtection()"
        >
          <i class='fa fa-save'></i>
          <span class='label ml-2'>Salvar</span>
        </b-button>
      </section>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'underscore'
import { rewriteHowWorkerIsExposedToChemicalAgents } from '@/services/hoFacilApiChat'

export default {
  name: 'PermanentExhibition',
  computed: {
    user() {
      return this.$store.getters['user/current']
    }
  },
  props: {
    disabled: { type: Boolean, require: false, default: false },
    productHierarchyId: { type: String, require: false, default: null },
    exposicaoPermanenteProps: { type: Object, require: true, default: null }
  },
  data() {
    return {
      exposicaoPermanente: {
        productHierarchyId: null,
        frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade: null,
        trabalhadorRealizeAtividadeSemPresencaSemNecessidadeEmpregoagentesQuimicos: null,
        trabalhadorexecutaAtividadeAgentesQuimicosAnalisados: null,
        exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao: null,
        foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente: null,
      },
      example: 'O trabalhador fica exposto ao agente [Nome do Agente], que é liberado através de [Fonte: ex. pintura a revólver / limpeza de peças], entrando em contato com o organismo por via [Respiratória / Cutânea], ocorrendo de forma [Frequência: ex. habitual e permanente] durante [Tempo: ex. 6 horas da jornada]',
      selectedActivities: [],
      functionalities: {
        home: 1,
        questionsPermanentExhibition: 2,
        questionsEffectiveProtection: 3
      },
      functionality: 1,
      home: 1,
      questionsPermanentExhibition: 2,
      questionsEffectiveProtection: 3,
      logs: new Set(),
      loading: false,
      loadingText: 'Atualizando...',
      technicalGuidanceUrl: 'https://docs.google.com/document/d/1KfQvIMFOLOLEdnzljkctGA9Y9U9KV7BDAchx3zAnYvo/edit?tab=t.0#heading=h.en6q55kyix9z',
    }
  },
  mounted() { },

  methods: {
    ...mapActions('effectiveProtection', {
      handleCreateEffectiveprotection: 'handleCreateEffectiveprotection',
      handleUpdateEffectiveprotection: 'handleUpdateEffectiveprotection',
      handleGetEffectiveprotection: 'handleGetEffectiveprotection',
      handleReset: 'handleReset'
    }),
    ...mapActions('permanentExhibition', {
      handleCreatePermanentExhibition: 'handleCreatePermanentExhibition',
      handleUpdatePermanentExhibition: 'handleUpdatePermanentExhibition',
      handleGetPermanentExhibition: 'handleGetPermanentExhibition',
      handleResetPermanentExhibition: 'handleResetPermanentExhibition'
    }),
    ...mapActions('userActionLogs', {
      createUserActionsLogs: 'createUserActionsLogs'
    }),

    hideEffectiveProtection() {
      this.$refs['permanent-exhibition'].hide()
    },

    hideQuidanceOnTopic() {
      this.$refs.guidanceOnTopic.hide()
    },

    showQuidanceOnTopic() {
      this.$refs.guidanceOnTopic.show()
    },

    async showModal() {
      this.exposicaoPermanente = {
        productHierarchyId: this.productHierarchyId,
        frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade: null,
        trabalhadorRealizeAtividadeSemPresencaSemNecessidadeEmpregoagentesQuimicos: null,
        trabalhadorexecutaAtividadeAgentesQuimicosAnalisados: null,
        exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao: null,
        foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente: null,
      }

      if (this.exposicaoPermanenteProps && this.exposicaoPermanenteProps._id) {
        this.exposicaoPermanente = this.exposicaoPermanenteProps
      }
      this.logs.clear()
    },

    async hideModal() {
      this.$emit('to-load')
      if (this.user && this.user.role !== 'admin' && this.logs.size > 0) {
        await this.createUserActionsLogs({ actions: Array.from(this.logs) })
      }
    },

    async updatePermanentExhibition() {
      this.$emit('updatePermanentExhibition', this.exposicaoPermanente)
    },

    async resetPermanentExhibition() {
      this.exposicaoPermanente.frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade = null
      this.exposicaoPermanente.trabalhadorRealizeAtividadeSemPresencaSemNecessidadeEmpregoagentesQuimicos = null
      this.exposicaoPermanente.trabalhadorexecutaAtividadeAgentesQuimicosAnalisados = null
      this.exposicaoPermanente.exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao = null
      this.exposicaoPermanente.foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente = null
      this.$emit('updatePermanentExhibition', this.exposicaoPermanente)
    },


  },
  watch: {
    exposicaoPermanenteProps() {
      this.exposicaoPermanente = this.exposicaoPermanenteProps
    },
  }
}
</script>

<style lang='scss' scoped>

.title {
  color: #022245;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

h1 {
  color: #022245;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.title_internal {
  color: #022245;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.subtitle {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 126.9%;

  a {
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
  }
}

label {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  color: #022245;

  .strong {
    font-weight: 700;
  }
}


.selected {
  color: #022245;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}

.not-selected {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.perguntas_1 {
  border-bottom: .5px solid #022245;
}

.btn_export {
  background-color: #CBD63E;
  color: #022245;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  line-height: 24px;

  i {
    color: #022245;
    margin-right: 6px;
  }

  img {
    width: 15px;
    height: 15px;
    margin-right: 6px;
  }
}

.divider {
  height: 1px;
  background: #C0C0C0;
  width: 100%;
}

.border-right {
  border-right: 1px dashed #C0C0C0 !important;
}

.btn_close {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  color: #022245;
  cursor: pointer;
  text-decoration: none;
  right: 0;
  top: -3px;
}

.guidanceOnTopic {
  font-family: Montserrat, sans-serif;

  a {
    cursor: pointer;
  }

  .title {
    color: #022245;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    margin-top: 5px;
  }

  p {
    color: #262626;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%; /* 18.9px */
    span {
      text-decoration: underline;
    }
  }

  #paragrafo_01, #paragrafo_02 {
    cursor: pointer;
  }
}

ul.pergunta_2_2_empregadosForamPrientadosTreinadosSobreUsoEPI, .pergunta_2_3_EPIFornecidoGratuitoEmpregadoAssimMomentoFornecimentoEstavaPerfeitoEstadoConservacaooFormaAdequadaRisco {
  list-style-type: upper-roman;
}
</style>
